<script lang="ts">
  import { locale, _, isLoading } from 'svelte-i18n';

  export let isOpen = false;
  export let title = 'Welcome';
  export let onClose: () => void;
  
  let isClosing = false;

  // Close modal on Escape key
  function handleKeydown(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      closeModal();
    }
  }
  
  // Handle backdrop click
  function handleBackdropClick() {
    closeModal();
  }

  function closeModal() {
    isClosing = true;
    setTimeout(() => {
      onClose();
    }, 300);
  }
</script>

{#if isOpen}
  <!-- svelte-ignore a11y-no-static-element-interactions -->
  <div 
    class="welcome-modal-backdrop" 
    on:click={handleBackdropClick} 
    on:keydown={handleKeydown}
    role="dialog"
    aria-modal="true"
    aria-labelledby="welcome-title"
  >
    <!-- svelte-ignore a11y-no-static-element-interactions -->
    <div class="welcome-modal" class:closing={isClosing} on:click|stopPropagation>
      <article>
        <header>
          <h3 id="welcome-title" class="mb-0">{title}</h3>
        </header>
        
        <main>
          <slot />
        </main>
        
        <footer class="flex justify-end">
          <slot name="footer">
            <button class="primary" on:click={closeModal}>
              {$_('common.close')}
            </button>
          </slot>
        </footer>
      </article>
    </div>
  </div>
{/if}

<style>
  .welcome-modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.25);
    display: flex;
    align-items: flex-end;
    justify-content: center;
    z-index: 1000;
    padding: 0 1rem 2rem 1rem;
  }
  
  .welcome-modal {
    width: 100%;
    max-width: 500px;
    animation: slideUp 0.3s ease-out;
    transform-origin: bottom;
    background: var(--pico-background-color);
  }
  
  .welcome-modal article {
    margin: 0;
    position: relative;
    border-radius: var(--pico-border-radius);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  }
  
  .welcome-modal header {
    padding-right: 3rem;
  }
  
  @keyframes slideUp {
    from {
      transform: translateY(100%);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
  
  /* Animation for closing */
  .welcome-modal.closing {
    animation: slideDown 0.3s ease-in;
  }
  
  @keyframes slideDown {
    from {
      transform: translateY(0);
      opacity: 1;
    }
    to {
      transform: translateY(100%);
      opacity: 0;
    }
  }
</style>